/*
 * @Description: 小区楼栋列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-06-28 10:10:12
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import { message, Divider, Popconfirm } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';

import AuthButton from '../../components/AuthButton/AuthButton';
import { postFrom, config } from '../../axios';
import {dicBuildingStatus, syncStatusIsMap} from '../../axios/dictionaries';
import BuildingAdd from './components/BuildingAdd';
import { handleExportParams, isPlatform } from '../../utils';
import AuthTable from '../../components/AuthTable';
import JrApiLog from "../Other/JrApiLog";

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_building_findBuildingPageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true })
        this.buildingAddRef.loadPack({ id })
    }

    handleJrApiLogInfo(tableName,id) {
        //console.log(this);
        this.jrApiLogRef.open(tableName,id);
    }

    handleRemove = (id) => { //删除
        this.setState({ tableLoading: false });
        let data = { buildingId: id };
        postFrom({ url: config.API_building_deleteBuilding, data }).then(res => {
            this.setState({ tableLoading: false });
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '删除失败');
            this.setState({ tableLoading: false });
        });
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
        } = this.state;

        let _column = columns({ handleEdit: this.handleEdit, handleRemove: this.handleRemove,handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) })

        // _column=_column.filter(e =>{
        //     //判断平台，如果是平台则返回true 商户则不显示同步状态及建融Id
        //     if(isPlatform()){
        //         return true;
        //     }
        //     return e.dataIndex!='name33';
        // });

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="c-2-3" type="primary" icon="plus" onClick={() => { this.buildingAddRef.initPack(); this.setState({ showAddModal: true }) }}>新增</AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <AuthTable actionKeyList={['c-2-2', 'c-2-4','c-2-5']}>
                    <TableDOM
                        columns={_column}
                        data={tableData}
                        loading={tableLoading}
                        total={tableTotal}
                        current={current}
                        onChange={this.handleSearch}
                        scroll={{x: 1500}}
                    />
                </AuthTable>
                <BuildingAdd
                    onRef={ref => this.buildingAddRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    handleGetList={this.handleSearch}
                />

                <JrApiLog ref={ref=>{
                    this.jrApiLogRef=ref;
                }}/>
            </PageWrap>
        )
    }


}

const searchData = () => {

    let data =[
    // {
    //     tagName: 'Select',
    //     formConfig: { name: 'syncStatus' },
    //     attribute: { placeholder: '请选择同步状态', style: { width: '160px' } },
    //     optionData: [{ title: '全部', value: '' }].concat(syncStatusIsMap), //.concat(dicHouseStatus)
    //     notResult: '',
    // },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字', style: { width: '160px' } },
        title: `在${handleExportParams().merchantId ? '' : '商户简称、'}小区/楼栋内模糊查询`
    },
];

    data = data.filter(e => {
        if(isPlatform()){
            return true;
        }
        if (e.formConfig.name === 'merchantName') {
            return false;
        }
        return true;
    });

    return data;

};
const columns = ({ handleEdit, handleRemove,handleJrApiLogInfo }) => [

    {
        title: '小区/楼栋名称',
        dataIndex: 'name'
        , width:200 ,fixed: 'left'
    },
    {
        title: '楼栋编码',
        dataIndex: 'buildingNo'
        , width:150
    },
    {
        title: '城市',
        dataIndex: 'city'
        , width:100
    },
    {
        title: '区域',
        dataIndex: 'area'
        , width:100
    },

    {
        title: '详细地址',
        dataIndex: 'address'
    },
    // {
    //     title: '同步状态 | 建融Id',
    //     dataIndex: 'name33',
    //     render(text, record, index) {
    //         return <span>
    //             <div>{record.jrCommunityId ? "同步成功" : "未同步"}</div>
    //             {
    //                 record.jrCommunityId
    //                     ? <React.Fragment>
    //                         <div>{record.jrCommunityId ? record.jrCommunityId : ''}</div>
    //                     </React.Fragment>
    //                     : null
    //             }
    //         </span>
    //     }
    // },
    // {
    //     title: '建融小区名称',
    //     dataIndex: 'jrCommunityName'
    // },
    {
        title: '发布状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicBuildingStatus.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '商户简称',
        dataIndex: 'shortName'
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 150,
         fixed: 'right',
        render(text, record, index) {
            return <span>
                <AuthButton authkey="c-2-2">
                    <span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span>
                        <Divider type="vertical" />
                </AuthButton>
                {/* <AuthButton authkey="c-2-5">*/}
                {/*    <span className="showClickDetail" onClick={() => { handleJrApiLogInfo("building",record.id) }}>建融日志</span>*/}
                {/*       <Divider type="vertical" />*/}
                {/*</AuthButton>*/}
                <AuthButton authkey="c-2-4">

                    <Popconfirm placement="top" title={"确定删除吗?"} onConfirm={() => { handleRemove(record.id) }} okText="删除" cancelText="不了">
                        <span className="showClickDetail">删除</span>
                    </Popconfirm>
                </AuthButton>
            </span>
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/House/Building.js